import { getCookie } from "cookies-next"

// List of supported locales
export const locales = ["en-CA", "fr-CA"]

/**
 * Get the preferred locale from browser
 * This is a client-side alternative to the middleware approach
 */
export function getPreferredLocale(): string {
  // First, check if there's a culture parameter in the URL
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href)
    const cultureParam = url.searchParams.get("culture")
    if (cultureParam && locales.includes(cultureParam)) {
      console.log("Using culture parameter:", cultureParam)
      return cultureParam
    }

    // Then, check if there's a cookie with a preferred locale
    const cookieLocale = getCookie("NEXT_LOCALE")?.toString()
    if (cookieLocale && locales.includes(cookieLocale)) {
      console.log("Using cookie locale:", cookieLocale)
      return cookieLocale
    }

    // Otherwise, use the browser's language
    const browserLang = navigator.language
    if (browserLang.startsWith("fr")) return "fr-CA"
  }

  // Default to English
  return "en-CA"
}

/**
 * Set the locale in a cookie
 */
export function setLocaleInCookie(locale: string): void {
  if (typeof document !== "undefined") {
    document.cookie = `NEXT_LOCALE=${locale}; max-age=${60 * 60 * 24 * 365}; path=/`
  }
} 